<div class="aarni-font relative block mt-[80px]">
    <picture>
        <source media="(min-width:1024px)" srcset="assets/img/admission-desktop-banners/Scholarship.jpg">
        <source media="(min-width:768px)" srcset="assets/img/admission-desktop-banners/medium-screen/medium-screen-scholarship.jpg">
        <img
            src="assets/img/admissions-mobile-banners/mobile-view-schloarship.jpg"
            alt="Faculty Banner"
            class="w-full h-auto"
        >
    </picture>
</div>

<div class="flex items-start justify-center p-4 bg-gray-50 aarni-font">
    <div class="flex flex-col lg:flex-row gap-4 p-4 w-full max-w-7xl">
        <aside class="w-full lg:w-1/4 space-y-4 lg:h-[950px] lg:overflow-y-auto">
            <div class="border-t-8 border-blue-400">
                <div class="bg-white shadow border border-gray-300">
                    <h2 class="text-lg font-bold p-4">Applying to ARNI</h2>
                    <div>
                        <a
                            href="/admissions/overview"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive('/admissions/overview'),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive('/admissions/overview')
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-y border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>Overview</span>
                        </a>

                        <a
                            *ngFor="let link of [
            { href: '/admissions/campus-virtual-tour', label: 'Campus Virtual Tour' },
            { href: '/admissions/criteria', label: 'Admission Criteria' },
            { href: '/admissions/flow', label: 'Admission Flow' },
            { href: '/admissions/program-fee', label: 'Program Fees' },
            { href: '/admissions/hostel-fee', label: 'Accommodation & Hostel' },
            { href: '/admissions/transportation-fee', label: 'Transportation Services' },
            { href: '/admissions/scholarship', label: 'Scholarship Opportunities' },
            { href: '/admissions/innovative-idea-scholarship', label: 'Innovative Idea Grants' },
            { href: '/admissions/fee-structure-for-previous-year-students', label: 'Fee Structures for Previous Year Students' },
            { href: '/admissions/education-loan-assistance', label: 'Education Loan Support' },
            { href: '/admissions/how-to-apply', label: 'How to Apply' },
            { href: '/quick-links/contact-us', label: 'Counseling Services' },
            { href: '/admissions/payment-procedure', label: 'Payment Procedure' },
            { href: '/admissions/refund-policy', label: 'Refund Policy' },
            { href: '/admissions/avenues-for-success', label: 'Avenues for Success@ARNI' },
            { href: '/admissions/lateral-entry-or-migration', label: 'Lateral Entry/Migration' },
            { href: '/admissions/faqs', label: 'FAQs' }
          ]"
                            [href]="link.href"
                            [ngClass]="{
            'bg-blue-600 text-white border-blue-400': isActive(link.href),
            'text-blue-600 hover:bg-blue-400 hover:text-white hover:border-blue-400': !isActive(link.href)
          }"
                            class="flex items-center space-x-2 p-3 w-full cursor-pointer border-b border-gray-300 transition duration-300"
                        >
                            <i class="fa fa-arrow-right"></i>
                            <span>{{ link.label }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </aside>
        <section class="flex-1 shadow-lg p-4 border-2 border-gray-200 h-fit bg-white aarni-font text-justify">
            <h2 class="text-2xl font-bold mb-4">ARNI Scholarship</h2>
            <p class="text-gray-800">
                At ARNI University, we believe that financial constraints should never become a barrier to quality
                education. With this vision, we offer a wide range of scholarships and financial aid programs that
                reward academic brilliance, support underprivileged students, and recognize excellence in co-curricular
                achievements.
            </p>
            <p class="mt-2 text-gray-800">
                Our scholarship programs are designed to motivate students and ease their academic journey, ensuring
                that deserving minds get every opportunity to learn, grow, and contribute meaningfully to society.
            </p>
            <p class="font-bold text-xl my-4">Government Scholarships</p>
            <p class="font-semibold text-lg mb-2 text-gray-800">ARNI University facilitates various government scholarship schemes for
                eligible students, including:
            </p>
            <ul class="list-disc pl-6 text-gray-800">
                <li>Himachal Pradesh Scholarships: Available for SC/ST/OBC candidates domiciled in Himachal Pradesh.
                </li>
                <li>Punjab Scholarships: Targeted at SC/OBC students from Punjab.</li>
                <li>Jammu & Kashmir Special Scholarship Scheme (JKSSS): For permanent residents of Jammu & Kashmir
                    pursuing higher education outside the state.
                </li>
                <li>Indian Army and Ministry of Defense Scholarships: For wards of serving and retired defense
                    personnel.
                </li>
            </ul>
            <div class="w-full mx-auto ">
                <div class="border-b border-gray-100 w-full">
                    <div *ngFor="let item of accordionData; let i = index" class="border-b">
                        <button
                            class="w-full flex justify-between items-center p-2 text-left font-semibold text-lg my-2"
                            (click)="toggleAccordion(i)"
                        >
                            <span>{{ item.title }}</span>
                            <i [class]="activeIndex === i ? 'fa fa-angle-up text-2xl' : 'fa fa-angle-down text-2xl'"></i>
                        </button>
                        <div *ngIf="activeIndex === i" class="p-6 bg-white">
                            <p class="text-md text-gray-800">{{ item.description }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="p-6">

                <h2 class="text-xl font-semibold mb-2">*Note*</h2>
                <div class="bg-blue-50 p-6 rounded-lg shadow-md">
                    <ul class="list-disc list-inside space-y-2 text-gray-700 text-gray-800">
                        <li>Only those students who have cleared their examinations in 2023/2024 will be eligible for a
                            scholarship.
                        </li>
                        <li>A student's academic performance shall be the sole criterion for the continuation of the
                            scholarship.
                        </li>
                        <li>Scholarship will be awarded on the Tuition Fee only. (Foreign Tour or any other charges
                            shall not be included)
                        </li>
                        <li>Scholarship would not apply if there is a gap between academic sessions.
                        </li>
                        <li>Scholarship will only be granted if the 10th & 12th board is the same.
                        </li>
                        <li>The grant of scholarship is subject to the approval of the Scholarship Committee.
                        </li>
                        <li>A maximum of one scholarship can be availed by the students, whichever is higher.
                        </li>
                        <li>Limited Scholarship seats are available, offered on a first-come, first-served basis.
                        </li>
                        <li>The Scholarship Committee reserves the right to review, modify, or cancel the awarded
                            scholarship due to any given circumstances as notified by the University.
                        </li>
                        <li>A detailed Scholarship Continuation Policy will be available on the website.
                        </li>
                    </ul>
                </div>
                <h2 class="text-xl font-bold my-4">Application Process</h2>
                <p class="font-semibold">To apply for scholarships or financial aid:
                </p>
                <ol class="list-decimal pl-6 text-gray-800">
                    <li>Visit the ARNI University Scholarship Portal.</li>
                    <li>Review the eligibility criteria for the desired scholarship.</li>
                    <li>Download and complete the relevant application forms.</li>
                    <li>Submit the completed forms along with necessary documents to the university's scholarship office.</li>
                </ol>
            </div>

        </section>
    </div>
</div>
